import { RouterUtil } from './router-util';

export class RouteUtil {
  static getCashTournamentRouteUrl(tournamentUrl: string) {
    return `/${RouterUtil.Configuration.CashTournaments}/${tournamentUrl}`;
  }
  static getPrizeTournamentDetailsRouteUrl(
    tournamentUrl: string,
    eventScheduleUuid: string,
  ) {
    return `/${RouterUtil.Configuration.PrizeTournaments}/${tournamentUrl}/${eventScheduleUuid}`;
  }

  static profileOverview = `/${RouterUtil.Configuration.Profile}${
    RouterUtil.Configuration.Profile !== '' ? '/' : ''
  }${RouterUtil.Configuration.ProfileOverview}`;
  static profileSecurity = `/${RouterUtil.Configuration.Profile}${
    RouterUtil.Configuration.Profile !== '' ? '/' : ''
  }${RouterUtil.Configuration.ProfileSecurity}`;
  static profileSettings = `/${RouterUtil.Configuration.Profile}${
    RouterUtil.Configuration.Profile !== '' ? '/' : ''
  }${RouterUtil.Configuration.ProfileSettings}`;
  static profileBusiness = `/${RouterUtil.Configuration.Profile}${
    RouterUtil.Configuration.Profile !== '' ? '/' : ''
  }${RouterUtil.Configuration.ProfileBusiness}`;
  static profileSettingsWinner = `/${RouterUtil.Configuration.Profile}${
    RouterUtil.Configuration.Profile !== '' ? '/' : ''
  }${RouterUtil.Configuration.ProfileSettingsWinner}`;
  static profileReferrals = `/${RouterUtil.Configuration.Profile}${
    RouterUtil.Configuration.Profile !== '' ? '/' : ''
  }${RouterUtil.Configuration.ProfileReferrals}`;
  static profileSubscriptions = `/${RouterUtil.Configuration.Profile}${
    RouterUtil.Configuration.Profile !== '' ? '/' : ''
  }${RouterUtil.Configuration.ProfileSubscriptions}`;
  static profilePreferences = `/${RouterUtil.Configuration.Profile}${
    RouterUtil.Configuration.Profile !== '' ? '/' : ''
  }${RouterUtil.Configuration.ProfilePreferences}`;
  static profilePrizes = `/${RouterUtil.Configuration.Profile}${
    RouterUtil.Configuration.Profile !== '' ? '/' : ''
  }${RouterUtil.Configuration.ProfilePrizes}`;
  static profilePromoCodes = `/${RouterUtil.Configuration.Profile}${
    RouterUtil.Configuration.Profile !== '' ? '/' : ''
  }${RouterUtil.Configuration.ProfilePromoCodes}`;
  static profileTaxForm = `/${RouterUtil.Configuration.Profile}${
    RouterUtil.Configuration.Profile !== '' ? '/' : ''
  }${RouterUtil.Configuration.ProfileTaxForm}`;

  static WalletDisabled = `/${RouterUtil.Configuration.Wallet}${
    RouterUtil.Configuration.Wallet !== '' ? '/' : ''
  }${RouterUtil.Configuration.WalletDisabled}`;
  static walletDeposit = `/${RouterUtil.Configuration.Wallet}${
    RouterUtil.Configuration.Wallet !== '' ? '/' : ''
  }${RouterUtil.Configuration.WalletDeposit}`;
  static walletWithdraw = `/${RouterUtil.Configuration.Wallet}${
    RouterUtil.Configuration.Wallet !== '' ? '/' : ''
  }${RouterUtil.Configuration.WalletWithdraw}`;
  static walletHistory = `/${RouterUtil.Configuration.Wallet}${
    RouterUtil.Configuration.Wallet !== '' ? '/' : ''
  }${RouterUtil.Configuration.WalletHistory}`;

  static becomeZbo = RouteUtil.profileSubscriptions;
}
